import { htmlPrefilter } from 'jquery';
import $ from 'jquery';
import './libs/sticky/jquery.sticky.js';
import './assets/js/main.js';
import './assets/js/moment-custom.js';
import './components/navBar/navBar.js';

import './assets/styles/styles.scss';